import { createGlobalState } from "react-hooks-global-state";
const initialState: any = {
  portfolioId: "0x62ED28802362bB79eF4cEe858d4F7aCA5eDd0490",
};
const { useGlobalState } = createGlobalState(initialState);

export { useGlobalState };
